import React, { useRef, useState } from 'react';
import { IconAlertTriangle, IconX } from '@tabler/icons-react';
import { Button } from '../../../shared/ui/Button';

interface DeleteParticipantModalProps {
  groupName: string;
  onClose: () => void;
  onConfirm: () => Promise<void>;
}

const DeleteParticipantModal: React.FC<DeleteParticipantModalProps> = ({ groupName, onClose, onConfirm }) => {
  const [deleting, setDeleting] = useState(false);
  const overlayRef = useRef<HTMLDivElement>(null);

  const handleConfirm = async () => {
    setDeleting(true);
    try {
      await onConfirm();
      onClose();
    } finally {
      setDeleting(false);
    }
  };

  return (
    <div className="mo open" ref={overlayRef} onClick={e => e.target === overlayRef.current && onClose()}>
      <div className="cm cm-create" style={{ maxWidth: 400 }}>
        <div className="cm-top">
          <div className="cm-ti">Удалить участника</div>
          <div className="cm-sp" />
          <button className="cm-x" type="button" onClick={onClose}>
            <IconX size={16} stroke={2} />
          </button>
        </div>
        <div className="cm-create-body" style={{ gap: 16 }}>
          <div className="adm-lb-delete-body">
            <div className="adm-lb-delete-icon">
              <IconAlertTriangle size={28} stroke={1.5} />
            </div>
            <p className="adm-lb-delete-text">
              Группа <strong>{groupName}</strong> будет удалена из лидер борда. Это действие необратимо.
            </p>
          </div>
          <div className="adm-form-actions">
            <Button variant="adm-cancel" type="button" onClick={onClose}>
              Отмена
            </Button>
            <Button variant="danger" type="button" disabled={deleting} onClick={handleConfirm}>
              {deleting ? '...' : 'Удалить'}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export { DeleteParticipantModal };
